/*
 * Deferred carousel cards.
 *
 * Product carousels (sections/product-list.liquid) render every product in their
 * collection - up to 50 cards each, 183 on the SALE page - although a shopper sees two
 * to four per carousel until they swipe. Each card is ~90 elements, six custom elements
 * and a quick-add form, and third-party scripts (Snapmint EMI, the Facebook pixel,
 * Shopify's pixel manager) walk every one of them during load. On a mid-range phone that
 * was ~9 s of style recalculation for cards nobody had scrolled to yet.
 *
 * The section now emits cards after the first four inside
 * <template data-jnorss-deferred>. Template content is inert: parsed, but never styled,
 * laid out, upgraded or scanned. This script swaps it in, per carousel:
 *   - four more cards in idle time once the carousel is within half a screen;
 *   - the rest on the first touch, hover, focus, wheel or scroll of that carousel.
 * The slide elements themselves are always rendered, so each carousel's slide count,
 * width, arrows and scroll snapping are exactly what they were.
 */
(function () {
  'use strict';

  if (window.JnorssDeferredSlides) return;

  var SELECTOR = 'template[data-jnorss-deferred]';
  var NEAR_BATCH = 4;
  var CHUNK = 6;
  var INTERACTIONS = ['touchstart', 'pointerdown', 'pointerenter', 'focusin', 'wheel', 'keydown'];

  var idle =
    typeof window.requestIdleCallback === 'function'
      ? function (callback) {
          return window.requestIdleCallback(callback, { timeout: 400 });
        }
      : function (callback) {
          return window.setTimeout(callback, 16);
        };

  // Snapmint adds its EMI line to the cards it finds at load and re-scans `.product-card`
  // on scroll. Ask it for the new cards straight away, so a card never appears without the
  // line and then jumps when the next scroll adds it.
  var emiTimer = null;

  function refreshEmi() {
    if (emiTimer) return;
    emiTimer = window.setTimeout(function () {
      emiTimer = null;
      try {
        if (typeof window.collectionList === 'function') window.collectionList('.product-card');
      } catch (error) {
        /* Snapmint still picks the cards up on the next scroll. */
      }
    }, 50);
  }

  function hydrateSome(root, count) {
    var list = root.querySelectorAll(SELECTOR);
    var done = 0;

    for (var i = 0; i < list.length && done < count; i += 1) {
      var template = list[i];
      if (!template.parentNode) continue;
      template.parentNode.replaceChild(template.content, template);
      done += 1;
    }

    if (done) refreshEmi();
    return list.length > done;
  }

  // Idle-time chunks keep a 40-card carousel from becoming one long task; the first chunk
  // is synchronous so the cards next to the visible ones exist before the swipe moves.
  function hydrateAll(root) {
    if (root.__jnorssHydrating) return;
    root.__jnorssHydrating = true;

    if (!hydrateSome(root, CHUNK)) return;

    (function next() {
      idle(function () {
        if (hydrateSome(root, CHUNK)) next();
      });
    })();
  }

  function arm(root) {
    var scroller = root.querySelector('slideshow-slides');

    function onInteract() {
      for (var i = 0; i < INTERACTIONS.length; i += 1) {
        root.removeEventListener(INTERACTIONS[i], onInteract, true);
      }
      if (scroller) scroller.removeEventListener('scroll', onInteract);
      hydrateAll(root);
    }

    for (var i = 0; i < INTERACTIONS.length; i += 1) {
      root.addEventListener(INTERACTIONS[i], onInteract, { capture: true, passive: true });
    }

    // scroll does not bubble; the carousel's own scroller reports arrow-button and
    // programmatic scrolling that none of the pointer events above would.
    if (scroller) scroller.addEventListener('scroll', onInteract, { passive: true });
  }

  var observer =
    typeof window.IntersectionObserver === 'function'
      ? new window.IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (!entry.isIntersecting) return;
              observer.unobserve(entry.target);
              idle(function () {
                hydrateSome(entry.target, NEAR_BATCH);
              });
            });
          },
          { rootMargin: '50% 0px' }
        )
      : null;

  function register(root) {
    if (root.__jnorssRegistered || !root.querySelector(SELECTOR)) return;
    root.__jnorssRegistered = true;

    arm(root);
    if (observer) observer.observe(root);
  }

  function scan() {
    var roots = document.querySelectorAll('[data-jnorss-deferred-root]');
    for (var i = 0; i < roots.length; i += 1) register(roots[i]);
  }

  window.JnorssDeferredSlides = { scan: scan, hydrateAll: hydrateAll };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan);
  else scan();

  // The theme editor re-renders sections in place.
  document.addEventListener('shopify:section:load', scan);
})();
